import React from "react"
import { Helmet } from "react-helmet"
import { Container } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import List from "./List"
function BannerAdsPayment() {
  const BreadcrumbDetails = {
    breadcrumbItem: {
      label: "List",
      link: "/payment/adverts/list",
    },
    paths: [
      {
        label: "Payments",
        link: "/payment/adverts/list",
      },
      {
        label: "Adverts",
        link: "/payment/adverts/list",
      },
    ],
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Payments Adverts | Discover Equestrian</title>
      </Helmet>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs breadcrumbDetails={BreadcrumbDetails} />

          <List />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default BannerAdsPayment
